import { RelatorioItem } from "../components/financeiro/RelatorioFinanceiroTable";

export function exportRelatorioToCSV(
  dados: RelatorioItem[],
  fileName: string
) {
  if (!dados.length) return;

  const headers = [
    "Franqueado",
    "Assinante",
    "Plano",
    "Valor Pago",
    "Data Pagamento",
    "Forma Pagamento",
    "Status",
  ];

  const rows = dados.map(item => [
    item.franqueado,
    item.cliente,
    item.plano,
    item.valorPago.toFixed(2),
    item.dataPagamento ?? "",
    item.formaPagamento ?? "",
    item.status ?? "",
  ]);

  const csvContent = [
    headers.join(";"),
    ...rows.map(r =>
      r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(";")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
}
